import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";
import {Cloneable} from "@/common/Cloneable";

import {ItemMergeMode} from "./ItemMergeMode";
import {RewardModel} from "../../reward/RewardModel";
import {RewardGeneratorModel} from "../../reward-generator/RewardGeneratorModel";


export class ItemMergeConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                if (!v) {
                    return SKIP;
                }

                if (!v.mode.equal(ItemMergeMode.CUSTOM)) {
                    v.generator = null;
                }

                return !v.empty() ? serialize(ItemMergeConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemMergeConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._mode = ItemMergeMode.DISABLED;
        this._reward = null;
        this._generator = null;
        this._onlyFirstReward = false;
        this._ignoreCopycat = false;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get generator() {
        return this._generator;
    }

    set generator(value) {
        this._generator = value;
    }

    get onlyFirstReward() {
        return this._onlyFirstReward;
    }

    set onlyFirstReward(value) {
        this._onlyFirstReward = value;
    }

    get ignoreCopycat() {
        return this._ignoreCopycat;
    }

    set ignoreCopycat(value) {
        this._ignoreCopycat = value;
    }

    valid() {
        if (this.mode.equal(ItemMergeMode.DISABLED)) {
            return true;
        } else if (this.mode.equal(ItemMergeMode.DEFAULT)) {
            return true;
        } else if (this.mode.equal(ItemMergeMode.CUSTOM)) {
            return this.generator && this.generator.valid();
        } else {
            return false;
        }
    }

    empty() {
        return this.mode.equal(ItemMergeMode.DISABLED);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemMergeConfig());
        } else if (target instanceof ItemMergeConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemMergeConfig, {
    _mode: alias("mode", ItemMergeMode.schema()),
    _reward: alias("reward", RewardModel.schema()),
    _generator: alias("generator", RewardGeneratorModel.schema()),
    _onlyFirstReward: alias("only_first_reward", Schema.primitive()),
    _ignoreCopycat: alias("ignore_copycat", Schema.primitive()),
});